<template>
  <BriefStep :title="title">
    <template v-slot:content>
      <div class="brief-form">
        <div class="brief-form">
          <div
            class="form__input-wrapper form__input-wrapper--check form__input-wrapper--check-squer"
            v-for="checkbox in formCheckboxes"
            :key="checkbox.name"
          >
            <input
              class="" :id="checkbox.name" type="checkbox" :name="checkbox.name"
              :value="checkbox.value"
              v-model.trim="form.siteColors"
              @input="invokeTouch($v.form.siteColors)"
              @click="hasDescription = false"
            >
            <label :for="checkbox.name" class="form__label">{{ checkbox.label }}</label>
          </div>
        </div>
      </div>
    </template>
  </BriefStep>
</template>
<script>
import { required } from 'vuelidate/lib/validators';
import stepValidation from '../../mixins/stepValidation';

import BriefStep from '../global/BriefStep.vue';

export default {
  name: 'SiteColors',
  components: { BriefStep },
  mixins: [stepValidation],
  data: () => ({
    title: 'Kolor potrafi wyrazić więcej niż tysiąc słów. W jakich barwach widzisz swoją stronę?',
    form: {
      siteColors: [],
    },
    formCheckboxes: [
      {
        name: 'sc-bright',
        value: 'jasna',
        label: 'jasna',
      },
      {
        name: 'sc-dark',
        value: 'ciemna',
        label: 'ciemna',
      },
      {
        name: 'sc-minima',
        value: 'oszczędna kolorystyka',
        label: 'oszczędna kolorystyka',
      },
      {
        name: 'sc-rich',
        value: 'bogata kolorystyka ',
        label: 'bogata kolorystyka ',
      },
      {
        name: 'sc-company',
        value: 'kolorystyka firmowa',
        label: 'kolorystyka firmowa',
      },
    ],
  }),
  validations: {
    form: {
      siteColors: {
        required,
      },
    },
  },
};
</script>
